import { IAudited } from '@interfaces/ehss/Audited';
import { IAuditor } from '@interfaces/ehss/Auditor';
import { AuditPersonType } from '@interfaces/audit-person-type';
import { Link } from 'react-router-dom';
import { Routes } from '@src/helpers/_routes';
import { IUser as UserInterface } from '@interfaces/IUser';
import AppContext from '@services/Context';
import AuditedService from '@services/ehss/Audited';
import AuditPersonDetails from '@components/AuditPersonDetailsComponent';
import ConfigService from '@services/global/Config';
import I18n from '../i18n';
import NotificationComponent from '../helpers/_showNotifications'
import Page from '@components/Page';
import React from 'react';
import styled from 'styled-components';
import UserService from '@services/UserService';

interface PropType { history: { replace: Function }; match: any; }

interface StateType {
    auditedsByAuditor: number;
    auditedsGoal: number;
    auditorData?: IAuditor;
    auditsGoal: number;
    audits?: any;
    curOffset?: string;
    curUsersOffset?: string,
    fields: any;
    filteredTableData: IAuditor[];
    haveAuditorSelected: boolean;
    iconLoading?: boolean;
    isLoading: boolean;
    loadingMoreAuditors: boolean;
    loadingMoreUsers: boolean;
    loadingUsersBySearch: boolean;
    personData?: IAudited;
    savingAuditor: boolean;
    searchAuditor: string;
    searchUser: string;
    serverResponse: any;
    showAuditorSavedModal: boolean;
    showFormModal: boolean;
    tableData: IAuditor[];
    usersData: any[];
    userSelectedItem: string;
    currentAuditId: string;
};

const tableColumns = [
    {
        title: 'table.users.auditor',
        dataIndex: 'name',
        key: 'name',
        width: '20%',
    },
    {
        title: 'table.auditors.registration',
        dataIndex: 'username',
        key: 'username',
        width: '20%',
    },
];

class AuditedDetails extends React.Component<PropType, StateType> {

    private idUnit: any = undefined;
    private _auditedService: AuditedService = new AuditedService();
    private _userService: UserService = new UserService();
    private _configService: ConfigService = new ConfigService();

    private _idPerson = this.props.match.params.id;


    constructor (props: any) {
        super(props);


        this.state = {
            isLoading: true,
            showFormModal: false,
            iconLoading: false,
            personData: undefined,
            tableData: [],
            usersData: [],
            auditorData: undefined,
            filteredTableData: [],
            curOffset: undefined,
            curUsersOffset: undefined,
            userSelectedItem: '',
            haveAuditorSelected: false,
            loadingUsersBySearch: false,
            loadingMoreUsers: false,
            loadingMoreAuditors: false,
            savingAuditor: false,
            showAuditorSavedModal: false,
            auditsGoal: 0,
            auditedsGoal: 0,
            auditedsByAuditor: 0,
            searchUser: '',
            searchAuditor: '',
            serverResponse: undefined,
            fields: undefined,
            currentAuditId: '',
        };
    }

    setUnit (unitId: string) {
        this.idUnit = unitId;
    }

    componentDidMount () {
        this.setState({ isLoading: true });
        this.getConfig();
    }

    toggleFormModal = () => {
        this.setState({
            usersData: [],
            userSelectedItem: '',
            haveAuditorSelected: false,
            searchUser: '',
            showFormModal: !this.state.showFormModal,
            serverResponse: undefined,
        });
    };

    getConfig = async () => {
        const responseGlobal = await this._configService.getGLOBAL(['userFields']);

        if (responseGlobal != undefined) {
            this.setState({
                fields: responseGlobal,
            });
        }
        this.getAuditedInfo();
    }

    getAuditedInfo = async () => {
        const response: IAudited = await this._auditedService.getById(this._idPerson);


        let auditor = undefined;
        if (response.audited != undefined)
            if (response.audited.auditorView != undefined)
                auditor = response.audited.auditorView;

        try {
            this.setState({
                isLoading: false,
                auditorData: auditor,
                personData: response,
            });

            this.formatAuditorsToTable();

        } catch (error) {
            NotificationComponent.Notify('error', 'Erro ao cadastrar', error);
            this.setState({
                savingAuditor: false,
                isLoading: false,
            });
        }
    }

    formatAuditorsToTable = async () => {
        const { auditorData } = this.state;

        const tableDataAux: IAuditor[] = Array.apply(null, { length: 1 });
        let nextTableData: any[] = [];

        if (auditorData != undefined) {
            tableDataAux[0] = auditorData;
            nextTableData.push(this.formatDataToTableSingle(auditorData));
        }

        this.setState({
            tableData: nextTableData,
            isLoading: false
        });
    }

    auditChanged = (auditId: string) => {
        this.setState({ currentAuditId: auditId });
    }

    handleUsersSearch = async () => {
        this.setState({
            loadingUsersBySearch: true,
        });

        this.getUsers(true);
    };

    handleUserSearchChange = (e: any) => {
        this.setState({
            searchUser: e.target.value,
        })
    }

    loadMoreUsers = () => {
        this.setState({ loadingMoreUsers: true, });
        this.getUsers(false);
    }

    getUsers = async (reset: boolean) => {
        if (reset) {
            this.setState({
                curUsersOffset: undefined
            });
        }
        try {
            if (this.state.searchUser.length > 0) {
                const data = await this._userService.paging({ unit: this.idUnit, to: undefined, from: undefined, search: this.state.searchUser, disabled: false, limit: 6, offset: this.state.curUsersOffset });
                let nextUsersData: UserInterface[] = [];

                if (!reset) {
                    nextUsersData = this.state.usersData || [];
                }
                nextUsersData = nextUsersData.concat(data.items);
                this.setState({
                    usersData: nextUsersData,
                    curUsersOffset: data.offset,
                    loadingMoreUsers: false,
                    loadingUsersBySearch: false,
                });
            }
            else {
                this.setState({
                    usersData: [],
                    curUsersOffset: undefined,
                    loadingMoreUsers: false,
                    loadingUsersBySearch: false,
                });
            }
        } catch (error) {
            NotificationComponent.Notify('error', 'Erro ao buscar usuários', error);
        }
    }


    formatDataToTableSingle = (item: IAuditor) => {
        let nextData: any;

        let linkAuditorDetails = <Link to={`${Routes.auditors}/${item.id}`}>{item.name}</Link>;
        nextData = {
            id: item.id,
            name: linkAuditorDetails,
            username: item.username,
        };

        return nextData;
    }

    onItemSelectionChange = async (e: any) => {
        this.setState({
            haveAuditorSelected: true,
            userSelectedItem: e.target.value,
        });
    }

    searchChange = async (event: any) => {
        event.preventDefault();
        this.setState({
            searchAuditor: event.target.value
        })
    };

    auditsTotal = (personData: any) => {
        if (personData && personData.audited && personData.audited.audits) {
            return personData.audited.audits.length
        }
        return 0
    }

    render () {
        const {
            isLoading,
            personData,
            tableData,
            auditsGoal,
            fields,
        } = this.state;

        if (!!isLoading) {
            return (
                <AppContext.Consumer>
                    {({ locale, activeUnitId }) => (
                        this.setUnit(activeUnitId),
                        <span>{I18n.l('common.loadingTable')}</span>
                    )}
                </AppContext.Consumer>
            );
        }

        return (
            <Page>
                <AppContext.Consumer>
                    {() => (
                        <Wrapper>
                            {personData != undefined && (
                                <AuditPersonDetails
                                    personData={personData}
                                    tableData={tableData}
                                    fields={fields}
                                    auditPersonType={AuditPersonType.AUDITED}
                                    audits={this.auditsTotal(personData)}
                                    auditsGoal={auditsGoal}
                                    tableColumns={tableColumns}
                                    auditChanged={this.auditChanged}
                                    calledFromAuditedsPage={true}
                                />
                            )}
                        </Wrapper>
                    )}
                </AppContext.Consumer>
            </Page>
        );
    }
}


const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;

  .emptyRowData{
      font-weight:bold;
      color:#B5B5B5;
  }

  .loading-more {
      margin: 15px 0;
      padding: 0;
      border: 0;
      text-align: left
  }

  .filter-group {
      margin-bottom: 50px;
  }
  .main-button {
      font-weight: bold;
      text-transform: uppercase;
      font-size:15px;
  }
  hr{
      opacity: .6;
  }
`;

export default AuditedDetails;